import type { History } from 'history';
import queryString from 'query-string';
import { useEffect } from 'react';
import { fromBrandedItemType, getQueryParams, toBrandedItemType } from 'venn-utils';

type LibraryHistory = History<{ shouldListenerIgnore?: boolean }>;

/**
 * Rewrites the retired Venn spelling of the itemType query param into the Risk Pro one, so a link saved
 * before the rebrand never leaves the old brand name in the URL. Both spellings resolve to the same
 * filter, so this only normalizes what the user sees.
 */
export const useBrandedItemTypeUrlNormalizer = (history: LibraryHistory) => {
  useEffect(() => {
    const normalize = ({ pathname, search }: LibraryHistory['location']) => {
      const queryParams = getQueryParams(search);
      const { itemType } = queryParams;
      if (typeof itemType !== 'string') {
        return;
      }
      const brandedItemType = toBrandedItemType(fromBrandedItemType(itemType));
      if (brandedItemType === itemType) {
        return;
      }
      history.replace(`${pathname}?${queryString.stringify({ ...queryParams, itemType: brandedItemType })}`, {
        shouldListenerIgnore: true,
      });
    };

    normalize(history.location);
    return history.listen(normalize);
  }, [history]);
};
